import { Image } from '@/components/Image';

export function TermsOfServiceModal({ onClick }: { onClick: () => void }) {
  return (
    <div className="fixed inset-0 w-full h-screen flex flex-col bg-white overflow-y-auto gap-10 pb-5 z-[11]">
      <div className="fixed top-0 left-0 w-full flex justify-between items-center p-5 border-b border-[#f5f5f5] bg-white">
        <span className="text-[30px] leading-9 font-extrabold">Terms of Service</span>
        <Image src="/icons/close.svg" alt="close" className="w-9 h-9 cursor-pointer" width={36} height={36} onClick={onClick} />
      </div>
      <div className="px-5 pb-[72px]">
        <Image src="/images/terms-of-service.png" alt="terms-of-service" width={1401} height={7557} />
      </div>
    </div>
  );
}
